import { AppMenuItem } from "./AppMenuItem"
import { ReactComponent as RequestIcon } from "icons/request-icon.svg";

interface AppMenuItemRfxProps {
	isCollapsed: boolean;
	link: string;
	total: number;
	onNavigate?: () => void;
}

export const AppMenuItemRfx = ({ link, onNavigate, total, isCollapsed }: AppMenuItemRfxProps) => {
	return <AppMenuItem
		name="RFx"
		icon={<RequestIcon />}
		link={link}
		total={total}
		isCollapsed={isCollapsed}
		testId="rfx"
		tourName="RFx"
		onNavigate={onNavigate}
	/>
}